import { DocumentDuplicateIcon } from '@heroicons/react/24/outline'
import classnames from 'classnames'
import {
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TelegramIcon,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton,
} from 'react-share'
import { useCopyToClipboard } from 'usehooks-ts'

import { Tooltip } from 'ui'

import type { FC } from 'react'

interface ShareProps {
  title: string
  url: string

  className?: string
  unique?: string
}

const Share: FC<ShareProps> = ({ className, title, unique, url }) => {
  const [, setCopied] = useCopyToClipboard()

  let shareURL = url
  if (unique) {
    shareURL = `${url}${url.indexOf('?') >= 0 ? '&' : '?'}v=${unique}`
  }

  return (
    <div className={classnames('flex gap-1 justify-end items-center px-1 py-2 *:rounded-full *:size-8', className)}>
      <Tooltip tooltip="Copiar link">
        <div
          className="bg-greyDark flex items-center justify-center text-white p-1.5 cursor-pointer"
          onClick={() => setCopied(shareURL)}
          onKeyDown={() => setCopied(shareURL)}
          role="button"
          tabIndex={0}
        >
          <DocumentDuplicateIcon className="size-6" />
        </div>
      </Tooltip>
      <Tooltip tooltip="Compartir en Whatsapp">
        <WhatsappShareButton title={title} url={shareURL}>
          <WhatsappIcon round size="100%" />
        </WhatsappShareButton>
      </Tooltip>
      <Tooltip tooltip="Compartir en Telegram">
        <TelegramShareButton title={title} url={shareURL}>
          <TelegramIcon round size="100%" />
        </TelegramShareButton>
      </Tooltip>
      <Tooltip tooltip="Compartir en 𝕏">
        <TwitterShareButton title={title} url={shareURL} via="SweatBits">
          <svg
            className="bg-black text-white rounded-full size-full p-0.5"
            fill="currentColor"
            version="1.1"
            viewBox="0 0 1668.56 1221.19"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g transform="translate(52.390088,-25.058597)">
              <path
                d="M283.94,167.31l386.39,516.64L281.5,1104h87.51l340.42-367.76L984.48,1104h297.8L874.15,558.3l361.92-390.99
		h-87.51l-313.51,338.7l-253.31-338.7H283.94z M412.63,231.77h136.81l604.13,807.76h-136.81L412.63,231.77z"
              />
            </g>
          </svg>
        </TwitterShareButton>
      </Tooltip>
      <Tooltip tooltip="Compartir en Facebook">
        <FacebookShareButton url={shareURL}>
          <FacebookIcon round size="100%" />
        </FacebookShareButton>
      </Tooltip>
      <Tooltip tooltip="Compartir en Linkedin">
        <LinkedinShareButton title={title} url={shareURL}>
          <LinkedinIcon round size="100%" />
        </LinkedinShareButton>
      </Tooltip>
    </div>
  )
}

export default Share
